import { images } from '../constants';

const services = [
{
  id: 1,
  image: images.service1,
  title: 'Card Design',
  content: 'High-impact card designs tailored for events, branding, and marketing to leave a lasting impression.',
  paragraphs: [
    'Our card design services deliver visually compelling and brand-consistent designs for business cards, invitation cards, thank-you notes, and more.',
    'From layout to typography and print finishes, we ensure each card reflects your personality or brand identity while maintaining clarity and elegance.'
  ],
  gallery: [
    images.service1Gallery1,
    images.service1Gallery2
  ],
  features: [
    'Custom Layout Design',
    'Typography & Font Styling',
    'Premium Print-Ready Formats',
    'Logo & Brand Integration',
    'Special Finishes (Foil, Emboss, etc.)'
  ],
  procedure: [
    'Client Brief & Requirements Gathering',
    'Initial Concepts & Variations',
    'Feedback & Refinement',
    'Final Design Approval',
    'Print Preparation & Delivery'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What types of cards do you design?',
      content: 'We design business cards, event invitations, greeting cards, thank-you cards, and more based on your needs.'
    },
    {
      id: 2,
      heading: 'Can I choose the paper and print finish?',
      content: 'Yes, we offer guidance on selecting the best paper stock and print techniques like matte, gloss, foil stamping, and embossing.'
    },
    {
      id: 3,
      heading: 'Do you provide print-ready files?',
      content: 'Absolutely. All final designs are delivered in high-resolution, print-ready formats such as PDF, AI, or EPS.'
    },
    {
      id: 4,
      heading: 'Can you match my brand guidelines?',
      content: 'Yes, we ensure that every card design aligns with your existing brand identity, including logos, colors, and fonts.'
    }
  ]
},
{
  id: 2,
  image: images.service2,
  title: 'Banner Printing',
  content: 'Durable and eye-catching banners for promotions, events, and branding—designed to make a bold statement indoors or outdoors.',
  paragraphs: [
    'Our banner printing services provide high-resolution visuals on sturdy materials suited for all weather conditions and applications.',
    'Whether it’s for trade shows, storefronts, or special events, we design and print banners that command attention and effectively communicate your message.'
  ],
  gallery: [
    images.service2Gallery1,
    images.service2Gallery2
  ],
  features: [
    'Custom Size & Layout Options',
    'Weather-Resistant Materials',
    'High-Resolution Printing',
    'Grommets & Hemming Included',
    'Design Assistance Available'
  ],
  procedure: [
    'Requirement Discussion & Sizing',
    'Design Mockups & Review',
    'Approval & Print Preparation',
    'Professional Printing',
    'Packaging & Delivery'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What types of banners do you print?',
      content: 'We print vinyl banners, mesh banners, fabric banners, and retractable banners for both indoor and outdoor use.'
    },
    {
      id: 2,
      heading: 'Can you help with banner design?',
      content: 'Yes, our in-house designers can create a banner layout that aligns with your goals and branding guidelines.'
    },
    {
      id: 3,
      heading: 'What sizes are available?',
      content: 'We offer fully customizable sizes to suit your needs—ranging from small tabletop banners to large-format outdoor signage.'
    },
    {
      id: 4,
      heading: 'How long does banner printing take?',
      content: 'Standard turnaround time is 3–5 business days, but rush options are available depending on project scope and volume.'
    }
  ]
},
{
  id: 3,
  image: images.service3,
  title: 'Flyer Printing',
  content: 'High-quality flyer printing for promotions, events, and marketing campaigns—crafted to grab attention and drive results.',
  paragraphs: [
    'Our flyer printing service delivers crisp visuals and vibrant colors on premium paper stock, perfect for spreading your message.',
    'Ideal for businesses, events, and product launches, our flyers are designed to be visually engaging and informative.'
  ],
  gallery: [
    images.service3Gallery1,
    images.service3Gallery2
  ],
  features: [
    'Single & Double-Sided Printing',
    'Glossy, Matte & Uncoated Options',
    'Various Paper Weights & Sizes',
    'Custom Design Support',
    'Fast Turnaround Time'
  ],
  procedure: [
    'Briefing & Requirements Gathering',
    'Design or Artwork Submission',
    'Proofing & Client Approval',
    'Flyer Printing & Finishing',
    'Packaging & Dispatch'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What flyer sizes do you offer?',
      content: 'We offer A4, A5, A6, DL, and custom sizes based on your campaign needs.'
    },
    {
      id: 2,
      heading: 'Can I print in full color on both sides?',
      content: 'Yes, we provide full-color printing on both sides of the flyer for maximum visual impact.'
    },
    {
      id: 3,
      heading: 'Do you help with flyer design?',
      content: 'Absolutely! Our graphic design team can create compelling flyer designs tailored to your brand and message.'
    },
    {
      id: 4,
      heading: 'What is the typical turnaround time?',
      content: 'Standard orders are completed within 2–4 business days, depending on quantity and design complexity.'
    }
  ]
},
{
  id: 4,
  image: images.service4,
  title: 'Shirt Printing',
  content: 'Custom shirt printing services for events, brands, and teams—delivering comfort, durability, and standout designs.',
  paragraphs: [
    'Our shirt printing service offers high-quality prints on a variety of shirt styles, fabrics, and colors to suit your personal or promotional needs.',
    'Whether it’s for a corporate event, sports team, or merchandise line, we ensure each shirt reflects your brand identity with precision and style.'
  ],
  gallery: [
    images.service4Gallery1,
    images.service4Gallery2
  ],
  features: [
    'Screen & Digital Printing Options',
    'Custom Designs & Logos',
    'Range of Shirt Styles & Sizes',
    'Durable Wash-Resistant Prints',
    'Bulk Order Discounts Available'
  ],
  procedure: [
    'Consultation & Design Discussion',
    'Shirt Selection & Sizing',
    'Artwork Finalization',
    'Printing & Quality Check',
    'Packaging & Delivery'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What printing methods do you offer?',
      content: 'We offer screen printing, heat transfer, DTG (direct-to-garment), and embroidery based on your needs.'
    },
    {
      id: 2,
      heading: 'Can I supply my own shirts for printing?',
      content: 'Yes, you can provide your own shirts, or choose from our wide range of available options.'
    },
    {
      id: 3,
      heading: 'Is there a minimum order quantity?',
      content: 'We accept both small and bulk orders. Minimum quantities may apply based on the print method chosen.'
    },
    {
      id: 4,
      heading: 'How long does production take?',
      content: 'Typical turnaround is 3–7 business days depending on quantity and print type.'
    }
  ]
},
{
  id: 5,
  image: images.service5,
  title: 'Package Design',
  content: 'Innovative and brand-focused packaging design solutions that enhance product appeal and drive consumer engagement.',
  paragraphs: [
    'We specialize in creating packaging that not only protects your product but also strengthens brand identity and shelf presence.',
    'From concept to print-ready files, our designers ensure your packaging is visually striking, functional, and aligned with market trends.'
  ],
  gallery: [
    images.service5Gallery1,
    images.service5Gallery2
  ],
  features: [
    'Custom Structural Packaging',
    'Creative Label & Box Designs',
    'Brand-Consistent Visuals',
    'Print-Ready Artwork Files',
    'Eco-Friendly Material Options'
  ],
  procedure: [
    'Client Brief & Product Research',
    'Concept Sketching & Mood Boards',
    'Digital Mockups & Revisions',
    'Final Design & Prepress Setup',
    'Production Coordination'
  ],
  faqs: [
    {
      id: 1,
      heading: 'Do you design packaging for all industries?',
      content: 'Yes, we create packaging for food, cosmetics, retail, tech products, and more—tailored to your industry needs.'
    },
    {
      id: 2,
      heading: 'Can you help with sourcing packaging materials?',
      content: 'We can guide you on material selection and connect you with reliable packaging suppliers.'
    },
    {
      id: 3,
      heading: 'Will I get print-ready files?',
      content: 'Absolutely. We provide high-resolution, press-ready files compatible with your printing vendor’s requirements.'
    },
    {
      id: 4,
      heading: 'Can you redesign existing packaging?',
      content: 'Yes, we offer redesign services to refresh or rebrand your current packaging for a more modern look.'
    }
  ]
},
{
  id: 6,
  image: images.service6,
  title: 'Mug Printing',
  content: 'Personalized and promotional mug printing services that make great gifts or branded merchandise.',
  paragraphs: [
    'Our mug printing service offers vibrant, long-lasting designs that are perfect for corporate giveaways, personal gifts, or marketing campaigns.',
    'We use high-quality materials and printing techniques to ensure your designs stay crisp and colorful through everyday use.'
  ],
  gallery: [
    images.service6Gallery1,
    images.service6Gallery2
  ],
  features: [
    'Full-Color Sublimation Printing',
    'Custom Text & Image Placement',
    'Dishwasher & Microwave Safe Options',
    'Bulk Order Discounts',
    'Gift Packaging Available'
  ],
  procedure: [
    'Design Submission or Consultation',
    'Mockup Preview & Approval',
    'High-Quality Printing Process',
    'Packaging & Quality Check',
    'Delivery or Pickup'
  ],
  faqs: [
    {
      id: 1,
      heading: 'What type of mugs do you offer?',
      content: 'We offer ceramic, color-changing, and travel mugs in various sizes and finishes.'
    },
    {
      id: 2,
      heading: 'Is there a minimum order quantity?',
      content: 'We accept single orders, but offer discounted pricing for bulk quantities.'
    },
    {
      id: 3,
      heading: 'Can I print photos and logos together?',
      content: 'Yes, you can mix text, photos, and logos in one design. We’ll help optimize it for the best print results.'
    },
    {
      id: 4,
      heading: 'Are the printed mugs dishwasher safe?',
      content: 'Yes, most of our printed mugs are dishwasher and microwave safe, depending on the material.'
    }
  ]
}

];

export default services;